export interface ChatClientAvailability {
  globallyEnabled?: boolean;
  routeEnabled?: boolean;
}

export const isChatClientSdkEnabled = ({
  globallyEnabled,
  routeEnabled,
}: ChatClientAvailability): boolean =>
  globallyEnabled === true && routeEnabled === true;
